import { VcaTriggerLandingPage } from '../shared/VcaTriggerLandingPage';
import { retentionNotesPreset } from '../shared/vcaNoteTemplates';
import type { ActionRunnerProps } from '../../types';
import type { VcaTriggerConfig } from '../shared/vca-trigger-config';

const RETENTION_CONFIG: VcaTriggerConfig = {
    notesPresets: [retentionNotesPreset],
    singular: 'retention',
    plural: 'retentions',
    eventType: 'retention_trigger',
    apiPath: 'retention',
    workflowAction: 'retention-needed',
    targetCaseStatus: 'Ready for retention',
    targetActionRequired: 'Review for retention',
    targetInternalCaseStatus: 'Ret - 1. Ready for retention',
    checkStep: { kind: 'caseChecklist' },
    notesPanelTitle: 'Retention notes'
};

function RetentionLandingPage(
    props: ActionRunnerProps & { onSubmitted?: (landedOn: string) => void }
) {
    return <VcaTriggerLandingPage {...props} config={RETENTION_CONFIG} />;
}

export { RetentionLandingPage };
